import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { TasksDto } from "cilor-db-api-shared";

@Injectable({
  providedIn: "root"
})
export class ActivityService implements OnDestroy {

  public data: TasksDto | null;
  public error: string | null;
  public loading: boolean;

  private timeout: number;

  constructor(
    private readonly httpClient: HttpClient,
  ) {
    this.data = null;
    this.error = null;
    this.loading = false;

    this.fetchData();
    this.timeout = setInterval(() => {
      this.fetchData();
    }, 5000);
  }

  public async getTasks(): Promise<TasksDto> {
    const data = await this.httpClient.get<TasksDto>("/api/tasks").toPromise();
    return data;
  }

  public fetchData(): void {

    /*
      Don't show loading indicator,
      because it would flash every few seconds.
     */
    if (this.data == null) {
      this.loading = true;
    }

    this.getTasks()
      .then((data: TasksDto) => {
        this.data = data;
      })
      .catch((error: Error) => {
        if (error instanceof HttpErrorResponse) {
          this.error = error.error.message;
        } else {
          this.error = error.message;
        }
      }).finally(() => {
        this.loading = false;
      });
  }

  public ngOnDestroy(): void {
    clearInterval(this.timeout);
  }
}
